/** Trim NWS Area Forecast Discussion (AFD) for the weather page. */

/** Build product URL from NWS products list entry (@id or bare UUID). */
export function resolveNwsProductUrl(entry: { id?: string; '@id'?: string }): string | null {
  const linked = entry['@id']?.trim();
  if (linked) return linked;
  const id = entry.id?.trim();
  if (!id) return null;
  if (id.startsWith('http')) return id;
  return `https://api.weather.gov/products/${id}`;
}

/** Drop aviation, point temps, and other technical tail sections. */
export function trimAreaDiscussionText(text: string): string {
  if (!text.trim()) return '';

  const normalized = text.replace(/\r\n/g, '\n').trim();

  const startPatterns = [/\.KEY MESSAGES/m, /\.SHORT TERM/m, /\.DISCUSSION/m];
  let start = -1;
  for (const rx of startPatterns) {
    const idx = normalized.search(rx);
    if (idx >= 0 && (start < 0 || idx < start)) start = idx;
  }
  let body = start >= 0 ? normalized.slice(start) : normalized;

  const cutRx = /\n&&\n\n\.(AVIATION|PRELIMINARY|HYDRO|MARINE|FIRE|CLIMATE|SPOT)/;
  const cut = body.search(cutRx);
  if (cut >= 0) body = body.slice(0, cut);

  return body.replace(/\n{3,}/g, '\n\n').trim();
}

/** Format NWS product issuance time for display in property timezone. */
export function formatAreaDiscussionUpdated(iso: string, timeZone: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(d);
}
